module.exports = __webpack_public_path__ + "prod/1.42.2/img/solutionHxyh.e07393aa.png";